"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowForward = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.ArrowForward = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { viewBox: "0 0 24 24", fill: "none" }),
    React.createElement("path", { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z", fill: props.fill }))); };
//# sourceMappingURL=arrowforward.js.map